import { toast } from "react-toastify";
import { api } from "../../../../utils/api";

export const onSubmitIndexReadjustment = async (
  resetIndex,
  setLoading,
  setVisible,
  data,
) => {
  try {
    setLoading(true);
    await api.post(`index-readjustment`, data);
    resetIndex();
    toast.success("Novo Índice Cadastrado com Sucesso!");
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.error
      : "Erro desconhecido ao cadastrar o Índice.";
    toast.error(`Não Possível Cadastrar o Índice! Erro: ${errorMessage}`);
  } finally {
    setLoading(false);
    setVisible(false);
  }
};
